import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var Inner = styled.p.withConfig({
  displayName: "Disclaimer__Inner",
  componentId: "sc-6hp929-0"
})(["margin-top:15px;", " ", ";"], getFont('-2'), maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), getFont('-3')));
export var Disclaimer = function Disclaimer(_ref) {
  var text = _ref.text;
  return text && React.createElement(Inner, null, text);
};